class WaitList {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
            this.currentOrganizationID = options.currentOrganizationID
            this.accountID = options.accountID
        }
    }
    fetch(options){
        return this.client.get(`/wait-lists`, {params: options})
    }
    create(options){
        return this.client.post(`/wait-lists`,options)
    }
    destroy(options){
        return this.client.delete(`/wait-lists/${options.id}`);
    }
}

export default WaitList


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/waitList.js